import util from 'util';
import assign from 'lodash-es/assign';
import isEqual from 'lodash-es/isEqual';
import get from 'lodash-es/get';
import G5Model from 'g5-component/src/scripts/model/master';
import modelHelpers from '../helpers/modelHelpers';


/**
 *
 * @name scoresViewModel
 *
 */
class ScoresModel extends G5Model {

    constructor(_opts) {

        /**
         *
         * @name opts
         * @description scores model default options
         *
         */
        const opts = assign({
            path: 'http://qa-statsapi.mlb.com'
        }, _opts);

        /**
         *
         * @name opts
         * @description scores model default options
         *
         */

        super(opts);

        /**
         *
         * @name props
         * @description scores model properties
         *
         */
        this.props = {
            instance: false,
            initial: true
        };

    }

   /**
     *
     * @method handleData
     * @description handle data
     *
     */
    handleData(response) {
        return JSON.parse(response);
    }

   /**
     *
     * @method handleSuccess
     * @description handle data success
     *
     */
    handleSuccess(data = {}) {

        if (!isEqual(data, this.dataCache)) {

            this.dataCache = data;
            this.emit('data', data);

            const { mode } = this.opts;

            if (mode === 'minisb') {
                const hasGames = get(data, 'dates[0].games.length', 0) > 0;

                // Being used in milb-site-core scoreboard pattern
                this.emit('check-for-games', hasGames);
            }

        }

    }

   /**
     *
     * @method handleError
     * @description handle errors
     *
     */
    handleError(err) {

        this.emit('data-error', err);

    }

    /**
     *
     * @method load
     * @description data fetch
     *
     */
    load() {

        const { opts, props } = this;
        const { handleData, handleSuccess, handleError } = this;
        const { constructPath } = modelHelpers;
        const { enablePolling, interval } = opts;

        util.log('mlbScores model - fetch');

        const path = constructPath(opts);

        this.xhr(path, handleError.bind(this), handleData.bind(this), handleSuccess.bind(this));

        props.initial = false;

        this.dataFetch = enablePolling && setTimeout(this.load.bind(this), interval);

    }

    /**
     *
     * @method loadDate
     * @param {Object} date
     * @description loads data for a particular date
     *
     */
    loadDate(date = '', config) {

        const dateRegex = /^(\d+-?)+\d+$/;
        const { opts } = this;

        if (!dateRegex.test(date)) {
            throw Error('Date should be dash delimited, i.e. "2016-01-01"');
        }

        if (config) {
            this.opts = assign(opts, config);
        }

        this.opts.date = date;
        this.dataCache = {};

        this.stop();
        this.load();

    }

    /**
     *
     * @method init
     * @description instantiate scores model
     *
     */
    init() {

        const { opts, props } = this;
        const { enableFetch } = opts;
        const { instance } = props;

        util.log('mlbScores model - init');

        if (enableFetch && !instance) {

            props.instance = true;

            this.load();

        }

    }

}

export default ScoresModel;
